export const TASK_DESCRIPTION_PREVIEW_LIMIT = 120;
